import { useState } from 'react';
import { Button } from 'common/components';

/**
 * Test component to manually trigger errors for ErrorBoundary testing
 * This component should only be used in development
 */
const ErrorTrigger = () => {
    const [shouldThrow, setShouldThrow] = useState(false);

    if (shouldThrow) {
        // This will trigger the ErrorBoundary
        throw new Error('Test error triggered for ErrorBoundary testing');
    }

    return (
        <div style={{ padding: '20px', border: '2px dashed #ff6b6b', borderRadius: '8px', margin: '10px' }}>
            <h3>🧪 ErrorBoundary Test Controls</h3>
            <p style={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
                Click the button below to trigger an error and test the ErrorBoundary
            </p>
            <Button onClick={() => setShouldThrow(true)} variant='primary' style={{ backgroundColor: '#ff6b6b' }}>
                Trigger Error
            </Button>
        </div>
    );
};

export default ErrorTrigger;
